import { render } from "./SectionFAQItem.vue?vue&type=template&id=1faeacaf&scoped=true"
import script from "./SectionFAQItem.vue?vue&type=script&lang=js"
export * from "./SectionFAQItem.vue?vue&type=script&lang=js"

import "./SectionFAQItem.vue?vue&type=style&index=0&id=1faeacaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1faeacaf"]])

export default __exports__